import React, { useCallback } from 'react';
import { Attachment as IAttachment } from '@/widget/domain/attachment';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import styles from './Attachment.module.scss';

interface Props {
  attachment: IAttachment;
}

function Attachment({ attachment }: Props) {
  const { settings } = useChatWidgetContext();
  const { textColor } = settings;

  const attachHTML = useCallback((attach) => {
    const image = attach.kind.split('/')[0] === 'image';
    if (image) {
      return (
        <div
          className={styles.img}
          style={{ backgroundImage: `url("${attach.url}")` }}
          onClick={() => window.open(attach.url, '_blank')}
        />
      );
    }
    return (
      <div className={styles.file} style={{ color: textColor }}>
        <a rel="noreferrer" target="_blank" href={attach.url}>{attach.title}</a>
      </div>
    );
  }, [textColor]);

  return (
    <>{attachHTML(attachment)}</>
  );
}

export default Attachment;
